import { render, staticRenderFns } from "./AdminTablePagination.vue?vue&type=template&id=eedda016"
import script from "./AdminTablePagination.vue?vue&type=script&lang=js"
export * from "./AdminTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports